<template>
  <div class="v2026-casedate" v-if="showCaseDate">
    <div>เคสสนทนาของวันที่: {{ formattedCaseDate }}</div>
    <div v-if="showOriginalDate">(สนทนาครั้งแรก: {{ createdAt | prettyDate }} )</div>
  </div>
</template>

<script>
import moment from 'moment'

const RECRUITMENT_TYPES = ['recruitment_customer', 'recruitment_professional', 'recruitment_professional_secondary']
const THAI_WEEKDAYS = ['วันอาทิตย์', 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์']
const THAI_MONTHS = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']

export default {
  name: 'conversation-case-date-v2026',
  props: {
    selectedConversation: {
      type: Object,
      default: null
    }
  },
  computed: {
    createdAt () {
      return this.selectedConversation ? this.selectedConversation.created_at : null
    },
    isRecruitment () {
      const type = this.selectedConversation ? this.selectedConversation.customer_type : null
      return RECRUITMENT_TYPES.includes(type)
    },
    formattedCaseDate () {
      if (!this.createdAt) return ''
      const d = this.caseDate(this.createdAt)
      if (!d.isValid()) return ''
      return `${THAI_WEEKDAYS[d.day()]} ${d.date()} ${THAI_MONTHS[d.month()]} ${d.year() + 543}`
    },
    showCaseDate () {
      return this.isRecruitment && !!this.formattedCaseDate
    },
    showOriginalDate () {
      return this.isRecruitment && this.isShifted(this.createdAt)
    }
  },
  methods: {
    // moment().add() mutates in place, so every call builds its own moment.
    caseDate (createdAt) {
      const d = moment(createdAt)
      if (!d.isValid()) return d
      return d.hour() >= 17 ? d.add(1, 'day') : d
    },
    isShifted (createdAt) {
      const d = moment(createdAt)
      return d.isValid() && d.hour() >= 17
    }
  }
}
</script>

<style scoped>
.v2026-casedate {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-muted);
  line-height: 1.5;
}
</style>
